import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOtherUserDetail, getOtherUserDetails } from "../../../redux/action/recipe";
import dummyPic from "../../../images/CW/profile.jpeg";
import { ImgUrl } from "../../../constants/const";
import OtherUserCommunity from "./OtherUserCommunity";
import OtherUserRecipe from "./OtherUserRecipe";
import OtherUserGallery from "./OtherUserGallery";
import Spinner from "../../../constants/Spinner";
import { Button, Image } from "antd";
import { sendFollowRequest } from "../../../redux/action/community";
import toast from '../../../constants/toast';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';

const NavigationButton = [
  {
    id: "1",
    title: "Uploads",
    fun: "U",
  },
  {
    id: "2",
    title: "Recipes",
    fun: "R",
  },
  {
    id: "3",
    title: "Community",
    fun: "C",
  },
];

const CommunityProfile = () => {
  const dispatch = useDispatch();
  const [active, setActive] = useState("U");
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState("1");
  const [otherUserData, setOtherUserData] = useState("");
  const [followRequest, setFollowRequest] = useState("Follow");

  let { id } = useParams();
  // const otherUserData = useSelector((state) => state.recipe?.other_user_detail?.data);
  const userData = useSelector((state) => state.dashboard?.user_data);
  const htmlString = otherUserData?.bio;

  const followUser = (id) => {
    const successCb = (resp) => {
      setFollowRequest('Requested')
      toast.success(resp?.message)
    };
    let data = { follow_to: id };
    dispatch(sendFollowRequest(data, successCb));
  }

  const getUserData = () => {
    setLoading(true)
    const success = (res) => {
      setLoading(false)
      setOtherUserData(res?.data)
    }
    const failure = (res) => {
      setLoading(false)
    }
    let data = {
      other_user_id: id
    }
    dispatch(getOtherUserDetails(data, success, failure))
  }

  useEffect(() => {
    getUserData();
  }, [])

  // useEffect(() => {
  //   // setLoading(true)
  //   let data = { other_user_id: id }
  //   dispatch(getOtherUserDetail(data));
  // }, []);



  return (
    <>
      {loading ? (<Spinner />) : (
        <Box>
          <Box style={{ marginBottom: "20px" }}>
            <Box className="profile__text__btn" style={{ margin: "0 0 20px 0" }} >
              <Typography className="common_medium_font">Profile</Typography>
              {otherUserData?._id !== userData?._id ?
                otherUserData.follow_request == "not_sent" ? <Button className="small_btn" onClick={() => { followUser(otherUserData?._id) }}>{followRequest}</Button> :
                  otherUserData.follow_request == "pending" ? <Button className="small_btn" >Requested</Button> : ""
                : ""}
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <Box style={{ display: "flex", flexDirection: "row", boxSizing: "border-box", }} className="profile_image_ansh" >
                  <Image className="imgSection--profile" src={otherUserData?.profile_pic !== "" ? `${ImgUrl}${otherUserData?.profile_pic}` : dummyPic} fallback={dummyPic} alt="profile_img" style={{ borderRadius: "50%" }} />
                </Box>
              </Grid>
              <Grid item xs={12} sm={9} md={9} lg={9} style={{ display: "grid", alignItems: "center" }} >
                <Box>
                  <Box style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "10px", }} >
                    <Typography> <strong style={{ fontWeight: "600" }}>Name</strong> </Typography>
                    <Typography><strong style={{ fontWeight: "600" }}> {otherUserData?.full_name ? otherUserData?.full_name : "---"} </strong> </Typography>
                  </Box>
                  <Box style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "10px", }} >
                    <Typography> <strong style={{ fontWeight: "600" }}>Username</strong> </Typography>
                    <Typography> <strong style={{ fontWeight: "600" }}> {otherUserData?.username ? otherUserData?.username : "---"} </strong> </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Box>
              <Typography className="common_medium_font">About Me</Typography>
              {otherUserData?.bio?.length > 0 ?
                <div style={{ maxHeight: '8rem', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: htmlString }} />
                : "---"}
            </Box>
            <div className="row g-2">
              {NavigationButton.map((data, key) => {
                return (
                  <div className="col-6 col-md-3 col-lg-3 col-xxl-2">
                    <Button className="common_btn w-100" onClick={() => { setActiveIndex(data.id); setActive(data.fun); }} style={{ backgroundColor: activeIndex === data.id ? "#F8931F" : "#fff", }} key={key} >
                      <Typography style={{ color: activeIndex === data.id ? "#fff" : "#F8931F", }} > {data.title}</Typography>
                    </Button>
                  </div>
                );
              })}
            </div>
            <Box style={{ maxHeight: "40vh", overflowY: "scroll" }} className="mt-3">
              {active === "U" && <OtherUserGallery />}
              {active === "R" && <OtherUserRecipe />}
              {active === "C" && <OtherUserCommunity />}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
export default CommunityProfile;